import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, FormGroup } from 'react-bootstrap';
import Dropdown from 'components/shared/dropdown/Dropdown';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import Input from 'components/shared/input/Input';
import TextArea from 'components/shared/input/TextArea';
import ImageUpload from 'components/shared/image-upload/ImageUpload';
import Number from 'components/shared/text/Number';
import './TaskDetails.css';
import { todayValidation } from 'services/utils/date-util';

class TaskDetails extends Component {
  static propTypes = {
    minMaxImages: PropTypes.object,
    readOnly: PropTypes.bool,
    task: PropTypes.shape({
      id: PropTypes.number,
      number: PropTypes.number,
      completionDate: PropTypes.string,
      trade: PropTypes.number,
      subTrade: PropTypes.number,
      floorNumber: PropTypes.string,
      room: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      status: PropTypes.string,
      images: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          url: PropTypes.string,
          file: PropTypes.shape({
            original: PropTypes.object,
            img: PropTypes.string,
          }),
        })
      ),
    }),
    trades: PropTypes.array,
    subTradesByTradeId: PropTypes.object,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNotesClick: PropTypes.func,
    onSubmit: PropTypes.func,
    onTaskImageRemove: PropTypes.func,
  };

  static defaultProps = {
    notesCount: 0,
    readOnly: false,
    showBidDueDate: false,
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.isValid()) {
      this.props.onSubmit();
    }
  };

  isValid = () => {
    if (this.props.task.trade === null) {
      alert('Type of task is required');
      return false;
    } else if (this.props.task.subTrade === null) {
      alert('Sub type of task is required');
      return false;
    } else if (this.props.task.completionDate === null) {
      alert('Completion date is required');
      return false;
    }

    return true;
  };

  handleAttributeChange = (value, attribute, label) => {
    this.props.onChange(this.props.task.id, attribute, value, label);
  };

  handleOnCancel = (event) => {
    event.preventDefault();
    this.props.onCancel();
  };

  handleNotesClick = (event) => {
    event.preventDefault();
    if (this.props.onNotesClick !== undefined) {
      this.props.onNotesClick();
    }
  };

  render() {
    const subTrades =
      this.props.subTradesByTradeId[this.props.task.trade] !== undefined
        ? this.props.subTradesByTradeId[this.props.task.trade]
        : [];
    return (
      <div className="task-details">
        <div className="title-container">
          <span>
            Task # <Number value={this.props.task.number} format={'00'} />:{' '}
            {this.props.task.name !== undefined ? this.props.task.name : ''}
          </span>
        </div>

        <Form horizontal onSubmit={this.handleSubmit}>
          <FormGroup>
            <Col md={6}>
              <div className="form-item-label">Trade</div>
              <Dropdown
                options={this.props.trades.map((element) => {
                  return { value: element.id, label: element.label };
                })}
                placeholder={'Trade'}
                readOnly={this.props.readOnly}
                theme={'underlined'}
                value={this.props.task.trade}
                onChange={(newOption) =>
                  this.handleAttributeChange(
                    newOption.value,
                    'trade',
                    newOption.label
                  )
                }
              />
            </Col>
            <Col md={6}>
              <div className="form-item-label">Sub Trades</div>
              <Dropdown
                disabled={subTrades.length === 0}
                options={
                  this.props.subTradesByTradeId[this.props.task.trade] !==
                  undefined
                    ? this.props.subTradesByTradeId[this.props.task.trade].map(
                        (element) => {
                          return { value: element.id, label: element.label };
                        }
                      )
                    : []
                }
                placeholder={'Sub Trade'}
                readOnly={this.props.readOnly}
                theme={'underlined'}
                value={this.props.task.subTrade}
                onChange={(newOption) =>
                  this.handleAttributeChange(
                    newOption.value,
                    'subTrade',
                    newOption.label
                  )
                }
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col md={6}>
              <div className="form-item-label">Floor</div>
              <Input
                placeholder="Floor"
                readOnly={this.props.readOnly}
                required={true}
                theme={'underlined'}
                value={this.props.task.floorNumber}
                onChange={(value) =>
                  this.handleAttributeChange(value, 'floorNumber')
                }
              />
            </Col>
            <Col md={6}>
              <div className="form-item-label">Room</div>
              <Input
                placeholder="Room"
                readOnly={this.props.readOnly}
                required={true}
                theme={'underlined'}
                value={this.props.task.room}
                onChange={(value) => this.handleAttributeChange(value, 'room')}
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col md={6}>
              <div className="form-item-label">Task Name</div>
              <Input
                placeholder="Task Name"
                readOnly={this.props.readOnly}
                required={true}
                theme={'underlined'}
                value={this.props.task.name || ''}
                onChange={(value) => this.handleAttributeChange(value, 'name')}
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col md={6}>
              <div className="form-item-label">Target Completion Date</div>
              <DatetimePicker
                className="completion-date"
                isValidDate={todayValidation}
                placeholder="Target Completion date"
                readOnly={this.props.readOnly}
                value={this.props.task.completionDate}
                theme={'underlined'}
                onChange={(value) =>
                  this.handleAttributeChange(value, 'completionDate')
                }
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col md={12}>
              <div className="form-item-label">Description</div>
              <TextArea
                className="description"
                placeholder="Description"
                readOnly={this.props.readOnly}
                required={true}
                value={this.props.task.description}
                theme={'underlined'}
                onChange={(value) =>
                  this.handleAttributeChange(value, 'description')
                }
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col md={12}>
              <ImageUpload
                extensions={['.jpg', '.jpeg', '.gif', '.png']}
                images={this.props.task.images}
                max={this.props.minMaxImages.max}
                notes="For faster quotes, provide photos - close-up, distant and one other that may help define your request"
                readOnly={this.props.readOnly}
                onRemove={this.props.onTaskImageRemove}
                onUpload={(images) =>
                  this.handleAttributeChange(images, 'images')
                }
              />
            </Col>
          </FormGroup>

          {!this.props.readOnly && (
            <div className="button-container">
              <input
                className="btn button button-orange"
                value="Save Task"
                type="submit"
              />
              <input
                className="btn button button-gray"
                value="Cancel Task"
                type="button"
                onClick={this.handleOnCancel}
              />
            </div>
          )}
        </Form>
      </div>
    );
  }
}

export default TaskDetails;



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/TaskDetails.js